"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var colour_1 = require("../theme/colour");
var size_1 = require("../theme/size");
function CrossIcon(_a) {
    var _b = _a.colour, colour = _b === void 0 ? colour_1.colours.grey[90] : _b, _c = _a.size, size = _c === void 0 ? size_1.IconSize.NORMAL : _c;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none" }, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.33474 4.33474C4.78105 3.88842 5.50467 3.88842 5.95098 4.33474L12 10.3838L18.049 4.33474C18.4953 3.88842 19.219 3.88842 19.6653 4.33474C20.1116 4.78105 20.1116 5.50467 19.6653 5.95098L13.6162 12L19.6653 18.049C20.1116 18.4953 20.1116 19.219 19.6653 19.6653C19.219 20.1116 18.4953 20.1116 18.049 19.6653L12 13.6162L5.95098 19.6653C5.50467 20.1116 4.78105 20.1116 4.33474 19.6653C3.88842 19.219 3.88842 18.4953 4.33474 18.049L10.3838 12L4.33474 5.95098C3.88842 5.50467 3.88842 4.78105 4.33474 4.33474Z", fill: colour }) })));
}
exports.CrossIcon = CrossIcon;
